export { default } from './posts-tags';
